import { getField, updateField } from 'vuex-map-fields'

export const state = {
	modalName: [],
	modalType: '',
	modalTitle: '',
	modalDesc: '',
	storeAction: '',
	storePayload: '',

	notificationName: [],
	notificationType: '',
	notificationTitle: '',
	notificationDesc: ''
}

export const actions = {
	closeModal ({ commit }) {
		commit('toggleModal', {
			modalName: '',
			modalType: '',
			modalTitle: '',
			modalDesc: '',
			storeAction: '',
			storePayload: ''
		})
	},

	errorModal ({ commit }, payload) {
		commit('toggleModal', {
			modalName: 'alert-modal',
			modalType: 'error',
			modalTitle: 'Oooops!',
			modalDesc: payload || 'Something went wrong!'
		})
	}
}

export const mutations = {
	updateField,

	toggleModal (state, {
		modalName = '', modalType = '', modalTitle = '',
		modalDesc = '', storeAction = '', storePayload = ''
	}) {
		if (modalName !== '') state.modalName.push(modalName)
		else state.modalName.pop()

		state.modalType = modalType
		state.modalTitle = modalTitle
		state.modalDesc = modalDesc
		state.storeAction = storeAction
		state.storePayload = storePayload
	},

	toggleNotification (state, {
		notificationName = '', notificationType = '',
		notificationTitle = '', notificationDesc = ''
	}) {
		if (notificationName !== '') {
			if (state.notificationName.indexOf(notificationName) === -1) state.notificationName.push(notificationName)
		} else {
			if (state.notificationName.length !== 0) state.notificationName.pop()
		}

		state.notificationType = notificationType
		state.notificationTitle = notificationTitle
		state.notificationDesc = notificationDesc
	},

	closeSpecificModal (state, { modalName }) {
		const modalNameIndex = state.modalName.indexOf(modalName)
		if (modalNameIndex > -1) state.modalName.splice(modalNameIndex, 1)
	}
}

const getters = {
	getField
}

export default {
	state,
	actions,
	mutations,
	getters
}
